import { render, staticRenderFns } from "./FormSelectListBreeds.vue?vue&type=template&id=95ac26c0&"
import script from "./FormSelectListBreeds.vue?vue&type=script&lang=js&"
export * from "./FormSelectListBreeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports